import { useEffect } from "react";


export default function useAutosizeTextarea(ref, value) {
    useEffect(() => {
        const ta = ref?.current;
        if (!ta) return;
        ta.style.height = "auto";
        ta.style.height = `${ta.scrollHeight}px`;
    }, [ref, value]);
}
